'use client';

import { LinkProps as NextLinkProps } from 'next/link';
import { JSX, lazy } from 'react';
import { useFramework } from '../../context/framework-context';

type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;
export type Anchor = NextLinkProps & AnchorProps;

const NextLink = lazy(() => import('next/link'));

export default function Anchor(props: Anchor): JSX.Element {
    const framework = useFramework();
    const { children, ...restProps } = props;

    if (framework === 'NextJS') {
        return <NextLink {...(props as NextLinkProps)} />;
    }

    return <a {...(restProps as AnchorProps)}>{children}</a>;
}
